// extracted by mini-css-extract-plugin
module.exports = {"dialogueActionButton":"ChooseBackgroundModal_dialogueActionButton__2zmTN"};